import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  _addPrize,
  _deletePrize,
  _editPrizes,
  _editProfile,
  _login,
  _organizationPrizes,
  _registerUser,
  _scheduleReminder,
  _kickUsers,
  _organizationName,
  _organizationMoods,
  _changePassword,
  _addPoints,
  _chatReport,
  _organizationData,
  _organizationPoints,
  _weeklyBonus,
  _organizationUpdate,
  _invitationCode,
  _userChats,
  _generalReport,
  _organizationChats,
  _chatMessages,
  _setPassword,
  _getAllOrganizations,
  _addOrganization,
  _deleteOrganization,
  _setRewardPoints,
  _setNotification,
  _requestMood,
  _redeemHistory,
  _organizationUsers,
  _getNotifications,
  _resetPasswordAdmin,
  _message,
  _getUserList,
  _getUserMessage,
  _sendUserMessage,
  _createOrganization,
  _requestCloseCase,
} from "./UserAPIs";

import { createAction, buildFromCreator } from "./ReduxTemplates";
import { statuses } from "./constants";

export const UserCreator = {
  login: createAction({
    name: "login",
    actionName: "user/login",
    route: "login",
    method: "POST",
    key: "user",
    omitAuth: true,
    pending: {
      message: "Logging in...",
    },
    fulfilled: {
      message: "Logged In!",
      cb: (s, a) => {
        if (["SuperAdmin", "Admin", "Support"].includes(a.payload.role)) {
          s.user = a.payload;
        } else {
          s.status.login = statuses.rejected;
          s.messages.login = "Login Failed!";
        }
      },
    },
    rejected: {
      message: "Login Rejected!",
    },
  }),
  organization: createAction({
    name: "organization",
    actionName: "user/organization",
    route: "organizations/",
    append: "organization",
    method: "GET",
    pending: {
      message: "Loading Organization Data...",
    },
    fulfilled: {
      message: "Organization Loaded!",
      cb: (s, a) => {
        s.organization = a.payload[0];
      },
    },
    rejected: {
      message: "Request Rejected!",
    },
  }),
  users: createAction({
    name: "users",
    actionName: "user/users",
    route: "users",
    method: "GET",
    pending: {
      message: "Loading Organization Data...",
    },
    fulfilled: {
      message: "Organization Loaded!",
      cb: (s, a) => {
        s.users = a.payload;
      },
    },
    rejected: {
      message: "Request Rejected!",
    },
  }),
  getUserMoods: createAction({
    name: "getUserMoods",
    actionName: "user/getUserMoods",
    route: "users/:id/moods",
    method: "GET",
    routeParameters: [{ ":id": "user" }],
    pending: {
      message: "Loading User Moods Moods...",
    },
    fulfilled: {
      message: "User Moods Loaded!",
      cb: (s, a) => {
        s.currentUserMoods = a.payload;
      },
    },
    rejected: {
      message: "Request Rejected!",
    },
  }),
  notifications: createAction({
    name: "notifications",
    actionName: "user/notifications",
    route: "notifications",
    method: "GET",
    pending: {
      message: "Loading Notifications...",
    },
    fulfilled: {
      message: "Notifications Loaded!",
      cb: (s, a) => {
        s.notifications = a.payload;
      },
    },
    rejected: {
      message: "Request Rejected!",
    },
  }),
  createNotification: createAction({
    name: "createNotification",
    actionName: "user/createNotification",
    route: "notifications",
    method: "POST",
    key: "notification",
    pending: {
      message: "Logging in...",
    },
    fulfilled: {
      message: "Notification Created",
    },
    rejected: {
      message: "Login Rejected!",
    },
  }),
  remindNotification: createAction({
    name: "remindNotification",
    actionName: "user/remindNotification",
    route: "notifications/:id/remind",
    method: "PUT",
    routeParameters: [{ ":id": "notification" }],
    pending: {
      message: "Loading Priority Moods...",
    },
    fulfilled: {
      message: "Priority Moods Loaded!",
    },
    rejected: {
      message: "Request Rejected!",
    },
  }),
  lastMoods: createAction({
    name: "lastMoods",
    actionName: "user/lastMoods",
    route: "moods/last",
    method: "GET",
    pending: {
      message: "Loading Latest Moods...",
    },
    fulfilled: {
      message: "Latest Moods Loaded!",
      cb: (s, a) => {
        s.lastMoods = a.payload;
      },
    },
    rejected: {
      message: "Request Rejected!",
    },
  }),
  priorities: createAction({
    name: "priority",
    actionName: "user/priority",
    route: "moods/priority",
    method: "GET",
    pending: {
      message: "Loading Priority Moods...",
    },
    fulfilled: {
      message: "Priority Moods Loaded!",
      cb: (s, a) => {
        s.priorities = a.payload;
      },
    },
    rejected: {
      message: "Request Rejected!",
    },
  }),
  moodScore: createAction({
    name: "moodScore",
    actionName: "user/moodScore",
    route: "organizations/:id/moodScore",
    method: "GET",
    routeParameters: [{ ":id": "organization" }],
    pending: {
      message: "Loading Priority Moods...",
    },
    fulfilled: {
      message: "Priority Moods Loaded!",
      cb: (s, a) => {
        s.moodScore = a.payload;
      },
    },
    rejected: {
      message: "Request Rejected!",
    },
  }),
  getReminders: createAction({
    name: "getReminders",
    actionName: "user/getReminders",
    route: "reminders",
    method: "GET",
    pending: {
      message: "Loading Priority Moods...",
    },
    fulfilled: {
      message: "Priority Moods Loaded!",
      cb: (s, a) => {
        s.reminders = a.payload;
      },
    },
    rejected: {
      message: "Request Rejected!",
    },
  }),
  createReminder: createAction({
    name: "createReminder",
    actionName: "user/createReminder",
    route: "reminders",
    method: "POST",
    key: "reminder",
    pending: {
      message: "Logging in...",
    },
    fulfilled: {
      message: "Notification Created",
    },
    rejected: {
      message: "Login Rejected!",
    },
  }),
  removeReminder: createAction({
    name: "removeReminder",
    actionName: "user/removeReminder",
    route: "reminders/:id",
    routeParameters: [{ ":id": "reminder" }],
    method: "DELETE",
    pending: {
      message: "Logging in...",
    },
    fulfilled: {
      message: "Notification Created",
    },
    rejected: {
      message: "Login Rejected!",
    },
  }),
  archiveUser: createAction({
    name: "archiveUser",
    actionName: "user/archiveUser",
    route: "users/:id",
    routeParameters: [{ ":id": "user" }],
    method: "DELETE",
    pending: {
      message: "Deleting...",
    },
    fulfilled: {
      message: "User Deleted",
    },
    rejected: {
      message: "Login Rejected!",
    },
  }),
};

export const [UserActions, UserReducers] = buildFromCreator(UserCreator);

const handleResponse = (res, ext) => {
  if (res.response.status === 422 || res.data.msg === "Token has expired") {
    alert("Your session has expired, please log in again!");
    ext.dispatch({ type: "user/logout" });
  }
  if (res.response.status !== 200) return ext.rejectWithValue(res.data.message);
  return res.data;
};

export const createOrganization = createAsyncThunk(
  "user/createOrganization",
  async (data, ext) => {
    try {
      const res = await _createOrganization(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const organizationPrizes = createAsyncThunk(
  "user/organizationPrizes",
  async (data, ext) => {
    try {
      const res = await _organizationPrizes(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const addPrize = createAsyncThunk("user/addPrize", async (data, ext) => {
  try {
    const res = await _addPrize(data, ext.getState());
    return handleResponse(res, ext);
  } catch (error) {
    return ext.rejectWithValue(error.message);
  }
});

export const deletePrize = createAsyncThunk(
  "user/deletePrize",
  async (data, ext) => {
    try {
      const res = await _deletePrize(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const editPrizes = createAsyncThunk(
  "user/editPrizes",
  async (data, ext) => {
    try {
      const res = await _editPrizes(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const organizationUsers = createAsyncThunk(
  "user/organizationUsers",
  async (data, ext) => {
    try {
      const res = await _organizationUsers(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const getNotifications = createAsyncThunk(
  "user/getNotifications",
  async (data, ext) => {
    try {
      const res = await _getNotifications(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const registerUser = createAsyncThunk(
  "user/registerUser",
  async (data, ext) => {
    try {
      const res = await _registerUser(data, ext.getState());
      if (res.response.status !== 200) ext.dispatch(organizationUsers(""));
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const editProfile = createAsyncThunk(
  "user/editProfile",
  async (data, ext) => {
    try {
      const res = await _editProfile(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const kickUsers = createAsyncThunk(
  "user/kickUsers",
  async (data, ext) => {
    console.log(data);
    try {
      const res = await _kickUsers(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const organizationName = createAsyncThunk(
  "user/organizationName",
  async (data, ext) => {
    try {
      const res = await _organizationName(data, ext.getState());
      if (res.response.status !== 200) ext.dispatch(organizationUsers(""));
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const organizationMoods = createAsyncThunk(
  "user/organizationMoods",
  async (data, ext) => {
    try {
      const res = await _organizationMoods(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const organizationData = createAsyncThunk(
  "user/organizationData",
  async (data, ext) => {
    try {
      const res = await _organizationData(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const scheduleReminder = createAsyncThunk(
  "user/scheduleReminder",
  async (data, ext) => {
    try {
      const res = await _scheduleReminder(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const changePassword = createAsyncThunk(
  "user/changePassword",
  async (data, ext) => {
    try {
      const res = await _changePassword(data);
      if (res.response.status !== 200)
        return ext.rejectWithValue(res.data.message);
      return res.data;
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const addPoints = createAsyncThunk(
  "user/addPoints",
  async (data, ext) => {
    try {
      const res = await _addPoints(data, ext.getState());
      if (res.response.status !== 200) ext.dispatch(organizationUsers(""));
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const chatReport = createAsyncThunk(
  "user/chatReport",
  async (data, ext) => {
    try {
      const res = await _chatReport(data, ext.getState());
      if (res.response.status !== 200) ext.dispatch(organizationUsers(""));
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const organizationPoints = createAsyncThunk(
  "user/organizationPoints",
  async (data, ext) => {
    try {
      const res = await _organizationPoints(data, ext.getState());
      if (res.response.status !== 200) ext.dispatch(organizationUsers(""));
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const weeklyBonus = createAsyncThunk(
  "user/weeklyBonus",
  async (data, ext) => {
    try {
      const res = await _weeklyBonus(data, ext.getState());
      if (res.response.status !== 200) ext.dispatch(organizationUsers(""));
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const organizationUpdate = createAsyncThunk(
  "user/organizationUpdate",
  async (data, ext) => {
    try {
      const res = await _organizationUpdate(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const invitationCode = createAsyncThunk(
  "user/invitationCode",
  async (data, ext) => {
    try {
      const res = await _invitationCode(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const userChats = createAsyncThunk(
  "user/userChats",
  async (data, ext) => {
    try {
      const res = await _userChats(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const generalReport = createAsyncThunk(
  "user/generalReport",
  async (data, ext) => {
    try {
      const res = await _generalReport(data, ext.getState());
      if (res.response.status !== 200) ext.dispatch(organizationUsers(""));
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const organizationChats = createAsyncThunk(
  "user/organizationChats",
  async (data, ext) => {
    try {
      const res = await _organizationChats(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const chatMessages = createAsyncThunk(
  "user/chatMessages",
  async (data, ext) => {
    try {
      const res = await _chatMessages(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const setPassword = createAsyncThunk(
  "user/setPassword",
  async (data, ext) => {
    try {
      const res = await _setPassword(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const getAllOrganizations = createAsyncThunk(
  "user/getAllOrganizations",
  async (data, ext) => {
    try {
      const res = await _getAllOrganizations(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const addOrganization = createAsyncThunk(
  "user/addOrganization",
  async (data, ext) => {
    try {
      const res = await _addOrganization(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const deleteOrganization = createAsyncThunk(
  "user/deleteOrganization",
  async (data, ext) => {
    try {
      const res = await _deleteOrganization(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const setRewardPoints = createAsyncThunk(
  "user/setRewardPoints",
  async (data, ext) => {
    try {
      const res = await _setRewardPoints(data, ext.getState());
      if (res.response.status !== 200) ext.dispatch(organizationUsers(""));
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const setNotification = createAsyncThunk(
  "user/setNotification",
  async (data, ext) => {
    try {
      const res = await _setNotification(data, ext.getState());
      if (res.response.status !== 200) ext.dispatch(organizationUsers(""));
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const requestMood = createAsyncThunk(
  "user/requestMood",
  async (data, ext) => {
    try {
      const res = await _requestMood(data, ext.getState());
      if (res.response.status !== 200) ext.dispatch(organizationUsers(""));
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const redeemHistory = createAsyncThunk(
  "user/redeemHistory",
  async (data, ext) => {
    try {
      const res = await _redeemHistory(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const resetPasswordAdmin = createAsyncThunk(
  "user/resetPasswordAdmin",
  async (data, ext) => {
    try {
      const res = await _resetPasswordAdmin(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const message = createAsyncThunk("user/message", async (data, ext) => {
  try {
    const res = await _message(data, ext.getState());
    return handleResponse(res, ext);
  } catch (error) {
    return ext.rejectWithValue(error.message);
  }
});

export const getUserList = createAsyncThunk(
  "user/getUserList",
  async (data, ext) => {
    try {
      const res = await _getUserList(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const getUserMessage = createAsyncThunk(
  "user/getUserMessage",
  async (data, ext) => {
    try {
      const res = await _getUserMessage(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const sendUserMessage = createAsyncThunk(
  "user/sendUserMessage",
  async (data, ext) => {
    try {
      const res = await _sendUserMessage(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);

export const requestCloseCase = createAsyncThunk(
  "user/requestCloseCase",
  async (data, ext) => {
    try {
      const res = await _requestCloseCase(data, ext.getState());
      return handleResponse(res, ext);
    } catch (error) {
      return ext.rejectWithValue(error.message);
    }
  }
);
